// POS gateway konfiqurasiyası.
//
// İki mənbədən oxunur:
//   1. window.rezmoPos  — Electron preload tərəfindən inject olunur (production POS app)
//   2. process.env.REACT_APP_POS_*  — brauzerdə dev/test üçün (.env.local)
//
// POS_ENABLED true olduqda gateway aktivləşir və POS-əməliyyat route-ları
// pos_local backend-inə yönlənir. Əks halda hər şey cloud-a gedir (köhnə davranış).

declare global {
  interface Window {
    rezmoPos?: {
      mode?: string;
      httpUrl?: string;
      wsUrl?: string;
      branchId?: string;
      /** Giriş ekranının bulud tokeni (quraşdırma kodundan gəlir). */
      appToken?: string;
      /** Kimlik quraşdırma kodu ilə idarə olunur — e-poçt/şifrə ekranı yoxdur. */
      deviceManaged?: boolean;
      /** Cihazın qoşulduğu buludun API kökü (`…/api`). */
      cloudApiUrl?: string;
    };
    /** Cihaz səviyyəli IPC (preload.js) — yalnız Electron-da mövcuddur. */
    rezmoDevice?: {
      reportRevoked(reason: string): Promise<{ ok: boolean }>;
    };
  }
}

const w = typeof window !== 'undefined' ? window.rezmoPos : undefined;

/** Electron içində işləyirik? */
export const IS_ELECTRON = w?.mode === 'electron';

/** POS gateway aktivdirmi? Electron-da həmişə, brauzerdə REACT_APP_POS_MODE=on ilə. */
export const POS_ENABLED =
  IS_ELECTRON || process.env.REACT_APP_POS_MODE === 'on';

/** pos_local HTTP base (sonunda / yox). */
export const POS_HTTP =
  w?.httpUrl || process.env.REACT_APP_POS_HTTP || 'http://127.0.0.1:7321';

/** pos_local WebSocket base. */
export const POS_WS =
  w?.wsUrl || process.env.REACT_APP_POS_WS || 'ws://127.0.0.1:7322';

/** .env-dəki BRANCH_ID ilə eyni olmalıdır (WS subscribe üçün). */
export const BRANCH_ID =
  w?.branchId || process.env.REACT_APP_POS_BRANCH || 'branch-demo';

/**
 * Quraşdırma kodundan gələn giriş tokeni.
 *
 * Bu var-sa POS terminalında e-poçt/şifrə ekranı ÜMUMİYYƏTLƏ göstərilmir —
 * cihaz artıq admin paneldə qeydiyyatdan keçib və onun kimliyi budur.
 */
export const POS_APP_TOKEN = w?.appToken || '';

/**
 * Cihazın kimliyini admin panel təyin edir (quraşdırılmış POS terminalı).
 *
 * Bu rejimdə giriş ekranında e-poçt/şifrə addımı YOXDUR və "Hesabı dəyiş"
 * düyməsi göstərilmir. Dev rejimində false-dur — orada quraşdırma kodu yoxdur
 * və köhnə axın yeganə giriş yoludur.
 */
export const POS_DEVICE_MANAGED = w?.deviceManaged === true;

/**
 * Cihazın öz bulud API ünvanı — quraşdırma kodundan gəlir.
 *
 * NİYƏ LAZIMDIR: `src/api/index.ts`-dəki `base_url` mənbə kodunda sabit
 * yazılıb. Terminal başqa buluda (sınaq mühiti, ayrıca server) qoşulsa da
 * giriş ekranı həmin sabit ünvana müraciət edirdi, token orada tapılmırdı və
 * cavab 401 olurdu — yəni düzgün quraşdırılmış cihaz "tanınmadı" görünürdü.
 *
 * Boş olduqda çağıran tərəf `base_url`-a qayıdır (brauzer və dev rejimi).
 */
export const POS_CLOUD_API = w?.cloudApiUrl || '';
